import { useEffect, useState } from 'react'
import Lottie from 'react-lottie';
import Dignoal from '../../../assests/OrangeSecondFlow.json'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './mainsection.css'

const heroImages = {
  desktop: [
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/Bringit%20Go%20Assets/abstract-universe-hands-digital-art%284000%2A2666%29.jpg',
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/Bringit%20Go%20Assets/holographic-infographic-smartphone_8809%2A5999.jpg',
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/Bringit%20Go%20Assets/universal-connectivity-concept%285000%2A3337%29.jpg',
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/future-smart-city-data-flow%285000%2A3333%29.jpg',
  ],
  mobile: [
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/abstract-universe-hands-digital-art%281200%2A799%29.jpg',
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/holographic-infographic-smartphone_1500.jpg',
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/universal-connectivity-concept_1100%2A734.jpg',
    'https://res.cloudinary.com/dlbm3b0oh/image/upload/future-smart-city-data-flow-900%2A599.jpg',
  ]
};

function MainSection() {
  const { t } = useTranslation();
  const nightMode = useSelector((state) => state.NightMode);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Responsive animation size
  const getLottieSize = () => {
    if (screenWidth < 576) return { width: 280, height: 40, paddingLeft: "30" };
    if (screenWidth < 992) return { width: 400, height: 80, paddingLeft: "30" };
    return { width: 600, height: 100, paddingLeft: "30" };
  };
  const SecondFlowOptions = {
    loop: true,
    autoplay: true,
    animationData: Dignoal,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);

    const currentImages = screenWidth < 768 ? heroImages.mobile : heroImages.desktop;
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === currentImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 7000);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, [nightMode, screenWidth]);

  const getBackgroundImage = () => {
    const currentImages = screenWidth < 768 ? heroImages.mobile : heroImages.desktop;
    return currentImages[currentImageIndex];
  };

  const { width, height, paddingLeft } = getLottieSize();
  return (
    <>
      <section className="main-section" aria-labelledby="home-hero-heading">
        <div
          style={{ backgroundImage: `url(${getBackgroundImage()})` }}
          className="background"
          aria-hidden="true"
        ></div>
        <Container className='main-container'>
          <Row>
            <Col lg={12} sm={12}>
              <h1 id="home-hero-heading" className="main-heading">
                {t("mainheading")}
              </h1>
              <div className='d-flex justify-self-center justify-content-center'>
                <div style={{ width: width, height: height, paddingLeft: `${paddingLeft}px` }}>
                  <Lottie className="" options={SecondFlowOptions} width={width} height={height} />
                </div>
              </div>
              <h2 className={`main-subheading`}>
                {t("mainsubheading")}
              </h2>
            </Col>

          </Row>
        </Container>
      </section>
    </>
  )
}

export default MainSection
